<router-outlet></router-outlet>
<div class="backdrop" [class.backdrop--visible]="loading$ | async"></div>
